<div
  *ngIf="isOpen$ | async"
  class="chat-shell"
  [class.expanded]="(isExpanded$ | async) === true"
  [class.dragging]="isDragging"
  [class.resizing]="isResizing"
  [ngStyle]="shellStyle"
>
  <div class="chat-card">
    <div class="chat-header" (pointerdown)="startDrag($event)">
      <div class="chat-title">
        <button 
          mat-icon-button 
          class="mobile-menu-btn" 
          (click)="toggleMobileHistory()"
          aria-label="Toggle history"
        >
          <mat-icon>{{ showMobileHistory ? 'close' : 'menu' }}</mat-icon>
        </button>

        <div class="chat-icon">
          <img class="chat-icon-logo" src="assets/images/forlabplus-logo-light.png" alt="" />
        </div>
        <div class="chat-meta">
          <div class="label">Supply Chain Agent</div>
          <div class="sub">Remaining tokens: {{ formatRemainingTokens((usageBalance$ | async) || null) }}</div>
        </div>
      </div>
      <div class="chat-actions">
        <button
          mat-icon-button
          class="compact-action-btn history-btn"
          *ngIf="(isExpanded$ | async) === false"
          (click)="openHistoryFullPage()"
          matTooltip="Open history full view"
          aria-label="Open chat history full view"
        >
          <mat-icon>history</mat-icon>
        </button>
        <button
          mat-icon-button
          class="compact-action-btn new-chat-icon-btn"
          *ngIf="(isExpanded$ | async) === false"
          (click)="startNewChat()"
          matTooltip="New chat"
          aria-label="Start new chat"
        >
          <mat-icon>add_comment</mat-icon>
        </button>
        <button
          mat-icon-button
          class="expand-btn"
          (click)="toggleExpand()"
          [matTooltip]="(isExpanded$ | async) ? 'Collapse window' : 'Expand window'"
          [attr.aria-label]="(isExpanded$ | async) ? 'Collapse chat window' : 'Expand chat window'"
        >
          <mat-icon>{{ (isExpanded$ | async) ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
        </button>
        <button
          mat-icon-button
          class="close-btn"
          (click)="close()"
          matTooltip="Close chat"
          aria-label="Close chat window"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div
      class="chat-body"
      [class.compact]="(isExpanded$ | async) === false"
      [class.expanded]="(isExpanded$ | async)"
      [class.mobile-history-open]="showMobileHistory"
    >
      <app-chat-history
        *ngIf="(isExpanded$ | async) || showMobileHistory"
        class="chat-history"
        [sessions]="(sessions$ | async) || []"
        [activeSessionId]="(activeSessionId$ | async) || null"
        (createNew)="startNewChat()"
        (sessionSelected)="selectSession($event)"
        (deleteSession)="deleteSession($event)"
      ></app-chat-history>

      <div
        class="chat-pane"
        [class.full-width]="(isExpanded$ | async) === false"
        [class.empty-chat]="(hasMessages$ | async) === false"
      >
        <div class="chat-scroll-region">
          <div
            class="starter-questions"
            *ngIf="
              (hasMessages$ | async) === false &&
              (((presetQuestions$ | async) || []).length > 0 || (presetQuestionsLoading$ | async) === true)
            "
          >
            <ng-container *ngIf="presetQuestions$ | async as presetQuestions">
              <div class="starter-group" *ngIf="presetQuestions.length > 0">
                <button
                  *ngFor="let preset of presetQuestions; trackBy: trackByPresetQuestionId"
                  mat-stroked-button
                  class="starter-btn preset-btn"
                  (click)="sendPresetQuestion(preset)"
                >
                  {{ preset.label }}
                </button>
              </div>
            </ng-container>
          </div>

          <app-chat-thread
            [messages]="(messages$ | async) || []"
            [isSending]="(isSending$ | async) || false"
            [error]="(error$ | async) || null"
            (clearError)="clearError()"
            (retryMessage)="retryAssistantMessage($event)"
            (feedbackSelected)="rateAssistantMessage($event)"
            (interactiveOptionSelected)="sendInteractiveSelection($event)"
          ></app-chat-thread>
        </div>

        <app-chat-input
          [disabled]="((isSending$ | async) || false) || ((hasInteractiveSelection$ | async) || false)"
          (send)="sendMessage($event)"
        ></app-chat-input>
      </div>
    </div>

    <span class="resize-handle resize-handle-n" (pointerdown)="startResize($event, 'n')" aria-hidden="true"></span>
    <span class="resize-handle resize-handle-e" (pointerdown)="startResize($event, 'e')" aria-hidden="true"></span>
    <span class="resize-handle resize-handle-s" (pointerdown)="startResize($event, 's')" aria-hidden="true"></span>
    <span class="resize-handle resize-handle-w" (pointerdown)="startResize($event, 'w')" aria-hidden="true"></span>
    <span class="resize-handle resize-handle-ne" (pointerdown)="startResize($event, 'ne')" aria-hidden="true"></span>
    <span class="resize-handle resize-handle-se" (pointerdown)="startResize($event, 'se')" aria-hidden="true"></span>
    <span class="resize-handle resize-handle-sw" (pointerdown)="startResize($event, 'sw')" aria-hidden="true"></span>
    <span class="resize-handle resize-handle-nw" (pointerdown)="startResize($event, 'nw')" aria-hidden="true"></span>
  </div>
</div>
